import { JAVA_API_STATUS } from '../../utils/axios-interceptor';
import { toast } from 'react-toastify';
import { fetchDataByConfig } from './ManageDealDrawerService';
import { LEAD_PRODUCT_ACCESS_FIELD, LEAD_PRODUCT_ACCESS_KEY, LEAD_PRODUCT_ACCESS_OPTIONS } from './DealDrawerConstants';

/** Appends the Lead Product Access dropdown to every profile section, for a super-admin editing a partner's profile. */
export function addLeadProductAccessField(pages: any[], isEditor: boolean): any[] {
    if (!isEditor) return pages;
    return pages.map((page) => ({
        ...page,
        config: (page?.config ?? []).map((section: any) =>
            section?.sectionKey === 'profile'
                ? { ...section, config: { ...section.config, [LEAD_PRODUCT_ACCESS_KEY]: LEAD_PRODUCT_ACCESS_FIELD } }
                : section,
        ),
    }));
}

type LeadProductAccessValue = (typeof LEAD_PRODUCT_ACCESS_OPTIONS)[keyof typeof LEAD_PRODUCT_ACCESS_OPTIONS];

export function isLeadProductAccessValue(v: unknown): v is LeadProductAccessValue {
    return (Object.values(LEAD_PRODUCT_ACCESS_OPTIONS) as unknown[]).includes(v);
}

/** A truthy but unrecognised stored value (e.g. a value from before the option set changed) defaults to All products instead of passing through raw. */
export function getLeadProductAccessValue(v: unknown): LeadProductAccessValue {
    return isLeadProductAccessValue(v) ? v : LEAD_PRODUCT_ACCESS_OPTIONS.ALL;
}

export async function getDataByConfig(payload: any, url: string, httpMethod: string, baseUrl?: string) {
    try {
        let response = await fetchDataByConfig(payload, url, httpMethod, baseUrl);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                return response?.data || [];
            case JAVA_API_STATUS.ERROR:
            default:
                toast.error('Error in fetching debt products data');
                return [];
        }
    } catch (err) {
        console.error('Error in fetching debt products data', err);
        return [];
    }
}
